import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [
    'buttonText',
    'buttonMessage',
    'addButton',
    'rowTemplate',
    'cellTemplate',
    'actionCellTemplate',
    'role',
    'form'
  ];

  static values = {
    editableClassList: { type: Array, default: [
      'px-4',
      'py-2',
      'border',
      'border-gray-300',
      'focus:outline-none',
      'hover:bg-gray-50'
    ]}
  }

  validateRoles() {
    const isAnyChecked = this.roleTargets.some(checkbox => checkbox.checked)

    this.roleTargets.forEach(checkbox => {
      checkbox.required = !isAnyChecked;
    });
  }

  addButton() {
    const table = this.element.querySelector('#ai-assistants-buttons-table');
    const rowSection = table.querySelector('.rows-section');
    const row = this.rowTemplateTarget.cloneNode(true).content.children[0];

    const buttonTextCell = this.cellTemplateTarget.cloneNode(true).content.children[0];
    buttonTextCell.classList.add('button-text-cell');

    const buttonMessageCell = this.cellTemplateTarget.cloneNode(true).content.children[0];
    buttonMessageCell.classList.add('button-message-cell');

    const actionCell = this.actionCellTemplateTarget.cloneNode(true).content.children[0];
    actionCell.classList.add('button-actions')

    buttonTextCell.textContent = this.buttonTextTarget.value;
    buttonMessageCell.textContent = this.buttonMessageTarget.value;

    this._appendHiddenInputs(actionCell, buttonTextCell, buttonMessageCell);

    row.appendChild(buttonTextCell);
    row.appendChild(buttonMessageCell);
    row.appendChild(actionCell);
    rowSection.appendChild(row);

    this._clearInputTargets();
  }

  editButton(event) {
    const buttonActionsContainer = event.target.closest('.button-actions');
    const rowContainer = buttonActionsContainer.closest('.table-body-row');

    this._toggleEditableCell(rowContainer, true);
    this._toggleIcons(buttonActionsContainer, true);
  }

  confirmEditing(event) {
    const buttonActionsContainer = event.target.closest('.button-actions');
    const rowContainer = buttonActionsContainer.closest('.table-body-row');
    const newButtonText = rowContainer.querySelector('.button-text-cell').textContent;
    const newButtonMessage = rowContainer.querySelector('.button-message-cell').textContent;

    this._toggleEditableCell(rowContainer, false);
    this._toggleIcons(buttonActionsContainer, false);
    this._saveNewValues(rowContainer, newButtonText, newButtonMessage);
  }

  cancelEditing(event) {
    const buttonActionsContainer = event.target.closest('.button-actions');
    const rowContainer = buttonActionsContainer.closest('.table-body-row');

    this._toggleEditableCell(rowContainer, false);
    this._toggleIcons(buttonActionsContainer, false);
    this._rollbackChanges(rowContainer, buttonActionsContainer);
  }

  deleteButton(event) {
    const buttonActionsContainer = event.target.closest('.button-actions');
    const rowContainer = buttonActionsContainer.closest('.table-body-row');

    rowContainer.remove();
    this._resetInputs();
  }

  updateButtonVisibility() {
    if (this.buttonTextTarget.value != '' && this.buttonMessageTarget.value != '') {
      this.addButtonTarget.disabled = false;
    } else {
      this.addButtonTarget.disabled = true;
    }
  }

  _appendHiddenInputs(actionContainer, buttonText, messageText) {
    let position = this._calculateNextPosition();

    let buttonTextInput = document.createElement('input');
    buttonTextInput.type = 'hidden';
    buttonTextInput.classList.add('button-text-input');
    buttonTextInput.name = `ai_assistant[prompts][${position}][button_text]`;
    buttonTextInput.value = buttonText.textContent;

    let buttonMessageInput = document.createElement('input');
    buttonMessageInput.type = 'hidden';
    buttonMessageInput.classList.add('button-message-input');
    buttonMessageInput.name = `ai_assistant[prompts][${position}][message]`;
    buttonMessageInput.value = messageText.textContent;

    actionContainer.appendChild(buttonTextInput);
    actionContainer.appendChild(buttonMessageInput);
  }

  _calculateNextPosition() {
    let rows = this.element.querySelectorAll('.table-body-row');
    return rows.length;
  }

  _clearInputTargets() {
    this.buttonTextTarget.value = '';
    this.buttonMessageTarget.value = '';
  }

  _toggleEditableCell(container, isEditable) {
    let buttonTextCell = container.querySelector('.button-text-cell');
    let buttonMessageCell = container.querySelector('.button-message-cell');

    buttonTextCell.setAttribute('contenteditable', isEditable);
    buttonMessageCell.setAttribute('contenteditable', isEditable);

    if (isEditable) {
      this.editableClassListValue.forEach((className) => {
        buttonTextCell.classList.add(className);
        buttonMessageCell.classList.add(className);
      });
    } else {
      this.editableClassListValue.forEach((className) => {
        buttonTextCell.classList.remove(className);
        buttonMessageCell.classList.remove(className);
      });
    }
  }

  _toggleIcons(container, isEditable) {
    let checkIcon = container.querySelector('.check-button');
    let cancelIcon = container.querySelector('.cancel-button');
    let editIcon = container.querySelector('.edit-button');
    let trashIcon = container.querySelector('.trash-button');

    if (isEditable) {
      checkIcon.classList.remove('hidden');
      cancelIcon.classList.remove('hidden');
      editIcon.classList.add('hidden');
      trashIcon.classList.add('hidden');
    } else {
      checkIcon.classList.add('hidden');
      cancelIcon.classList.add('hidden');
      editIcon.classList.remove('hidden');
      trashIcon.classList.remove('hidden');
    }
  }

  _saveNewValues(container, newButtonText, newButtonMessage) {
    let buttonTextInput = container.querySelector('.button-text-input');
    let buttonMessageInput = container.querySelector('.button-message-input');

    buttonTextInput.value = newButtonText.trim();
    buttonMessageInput.value = newButtonMessage.trim();
  }

  _rollbackChanges(rowContainer, buttonActionsContainer) {
    let buttonTextCell = rowContainer.querySelector('.button-text-cell');
    let buttonMessageCell = rowContainer.querySelector('.button-message-cell');

    let buttonTextInput = rowContainer.querySelector('.button-text-input');
    let buttonMessageInput = rowContainer.querySelector('.button-message-input');

    buttonTextCell.textContent = buttonTextInput.value;
    buttonMessageCell.textContent = buttonMessageInput.value;
  }

  _resetInputs() {
    const table = this.element.querySelector('#ai-assistants-buttons-table');
    const rows = table.querySelectorAll('.table-body-row');
    let position = 0;

    if (rows.length < 1) return;

    rows.forEach((row) => {
      const buttonTextInput = row.querySelector('.button-text-input');
      const buttonMessageInput = row.querySelector('.button-message-input');

      buttonTextInput.name = `ai_assistant[prompts][${position}][button_text]`;
      buttonMessageInput.name = `ai_assistant[prompts][${position}][message]`;
      position++;
    });
  }
}
